export enum PARAMETERS_ENDPOINTS {
  GET_PARAMETERS = '/',
  UPDATE_PARAMETERS = '/update-parameters'
}